import { LogLevel, Configuration } from '@azure/msal-browser';

interface Account {
  username?: string;
}

export const createMsalConfig = (clientId: string, tenantId: string): Configuration => ({
  auth: {
    clientId: clientId || '',
    authority: `https://login.microsoftonline.com/${tenantId}`,
    redirectUri: window.location.hostname === 'localhost'
      ? 'http://localhost:3000/auth/callback'
      : process.env.REACT_APP_AZURE_REDIRECT_URI || window.location.origin + '/auth/callback',
    postLogoutRedirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level: LogLevel, message: string, containsPii: boolean) => {
        if (process.env.NODE_ENV === 'development' && !containsPii) {
          switch (level) {
            case LogLevel.Error:
              console.error('MSAL Error:', message);
              return;
            case LogLevel.Warning:
              console.warn('MSAL Warning:', message);
              return;
            default:
              return;
          }
        }
      },
    },
  },
});

export const loginRequest = {
  scopes: ['User.Read', 'openid', 'profile'],
  prompt: 'select_account',
};

export const AUTH_SCOPES = loginRequest.scopes as string[];


export const validateMorganMorganUser = (account: Account) => {
  const allowedDomains = ['@forthepeople.com'];
  return allowedDomains.some(domain => 
    account.username?.toLowerCase().endsWith(domain.toLowerCase())
  );
};
